import { UnitsSystem } from '@App/app/entities/shared/units.model';
import { Component, Input } from '@angular/core';

/**
 * A labelled dimension row that renders a length value through the lengthUnit
 * pipe. Shared by the cuboid and rect-tube property panels.
 */
@Component({
  selector: 'app-layer-details-dimension-row',
  templateUrl: './layer-details-dimension-row.component.html',
})
export class LayerDetailsDimensionRowComponent {
  @Input() label: string;
  @Input() value: number;
  @Input() unitsSystem: UnitsSystem;
}
